import axios from 'axios'
import router from '@/router';
import {checkAuthorization, getAuthorization} from "@/utils/authorization-store"

/**
 * 解决 IE "URLSearchParams未定义" 错误
 */
import 'url-search-params-polyfill';

let baseURL = process.env.VUE_APP_BASEURL;

axios.defaults.baseURL = baseURL;

let instance = axios.create({
    baseURL: baseURL,
    headers: {},
    timeout: 600000
})

// 请求拦截器
instance.interceptors.request.use(config => {
    if (checkAuthorization()) {
        let authentication = getAuthorization();
        config.headers.Authorization = `Bearer ${authentication.token}`;
    }
    return config
}, error => {
    return Promise.reject(error)
})

// 响应拦截器（Http状态码）
instance.interceptors.response.use(response => {
    switch (response.data.code) {
        case "200":
            return response.data;
        case "401":
            if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                router.push({path: '/mobile/login'});
            } else {
                router.push({path: '/login'});
            }
            return response.data;
        default:
            return response.data;
    }
});

// 响应处理
function responseHandle(res, resolve, reject) {
    if (res.code === "200") {
        resolve(res);
    } else {
        reject(res);
    }
}

// 异常处理
function catchHandle(ex, resolve, reject) {
    reject({
        code: 400,
        message: ex.message,
        data: ex
    });
}


export const Request = {

    get: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'get',
                url: url,
                params: data
            }).then(
                res => {
                    responseHandle(res, resolve, reject);
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });
    },

    download: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'get',
                url: url,
                params: data,
                responseType: "blob"
            }).then(
                res => {
                    if (res.type === "application/json") {
                        let reader = new FileReader()
                        reader.onload = e => responseHandle(JSON.parse(e.target.result), resolve, reject)
                        reader.readAsText(res)
                    } else {
                        resolve(res);
                    }
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });
    },

    export: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'post',
                url: url,
                data: data,
                responseType: "blob",
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(
                res => {
                    if (res.type === "application/json") {
                        let reader = new FileReader()
                        reader.onload = e => responseHandle(JSON.parse(e.target.result), resolve, reject)
                        reader.readAsText(res)
                    } else {
                        resolve(res);
                    }
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });
    },

    post: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'post',
                url: url,
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(
                res => {
                    responseHandle(res, resolve, reject);
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });

    },

    upload: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'post',
                url: url,
                data: data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(
                res => {
                    responseHandle(res, resolve, reject);
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });

    },

    put: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'put',
                url: url,
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(
                res => {
                    responseHandle(res, resolve, reject);
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });

    },

    formPost: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'post',
                url: url,
                data: data
            }).then(
                res => {
                    responseHandle(res, resolve, reject);
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });

    },

    delete: (url, data) => {
        return new Promise((resolve, reject) => {
            instance({
                method: 'delete',
                url: url,
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(
                res => {
                    responseHandle(res, resolve, reject);
                }
            ).catch(
                ex => {
                    catchHandle(ex, resolve, reject);
                }
            )
        });
    },

};
